<template>
  <div >
      <div class="customHeight">

    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="heading">Search Delivery Order</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSaveUser">
          <div class="SpinnerAdj">
            <callingApiCenter
              type="bar"
              :paths="[
                '/api/w/DOs/WebSearchBooking',
                '/api/w/users',
                '/api/w/DOs/WebMoveLoad',
              ]"
            >
            </callingApiCenter>
          </div>

          <div v-if="getSearchBox == true">
            <div class="inputBoxDouble">

              <div class="inputBox">
                <md-field>
                  <label>Sales Office</label>
                  <md-input v-model="dataForm.salesOffice" disabled/>
                </md-field>
              </div>


              <div class = "inputBox">
                <master-data-select 
                  label="Order Type" 
                  group="GST_DELIVERYTYPE" 
                  v-model="dataForm.deliveryType"
                  @keyup.enter="doSearch"/>
              </div>

              <div class="inputBox">
                <datepicker v-model="dataForm.cutLFD.startDate">
                  <label>Cut off Date</label>
                </datepicker>
              </div>


              <div class="inputBox">
                <datepicker v-model="dataForm.cutLFD.endDate">
                  <label>To</label>
                </datepicker>
              </div>

            </div>

            <div class="inputBoxDouble">
              <!-- <div class = "inputBox">
                <md-field>
                  <label>Delivery Order</label>
                  <md-input v-model="dataForm.deliveryOrder"/>
                </md-field>
              </div> -->



              <div class = "inputBox">
                <master-data-select 
                  label="Status" 
                  group="GST_DO_STATUS" 
                  v-model="dataForm.deliveryStatus"/>
              </div>
              
              <div class = "inputBox">
                <md-field>
                  <label>Cust PO</label>
                  <md-input v-model="dataForm.customerPO"/>
                </md-field>
              </div>

              <div class="inputBox">
                <md-field>
                  <label>Booking#</label>
                  <md-input v-model="dataForm.bookObl" />
                </md-field>
              </div>

              <div class="inputBox">
                <md-field>
                  <label>Material</label>
                  <md-input v-model="dataForm.grade" />
                </md-field>
              </div>

            </div>

            <div class="inputBoxDouble">


              <div class="inputBox">
                <md-field>
                  <label>Sort</label>
                  <md-input v-model="dataForm.sort1" />
                </md-field>
              </div>

              <div class = "inputBoxWide">
                <master-data-select 
                label="Ctnr Type" 
                group="CCR_CNTRTYPE" 
                v-model="dataForm.ctnrType"/>
              </div>

              <div class = "inputBoxWide">
                <master-data-select 
                label="SCAC" 
                group="STC_CARRIER" 
                v-model="dataForm.scac"/>
              </div>
            </div>


            <div class= "inputBoxMessage">
              <b-notification class = "notifySize"
                  type="is-danger"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
              </b-notification>

            </div>


            <div class="inputBoxDouble">

              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="clearAction"
                  ><span class="icons-center material-icons">cancel</span
                  >Clear</md-button
                > 
              </div>

              <div class="inputBtnSpace">
                <md-button
                  class="md-raised custButtonWide"
                  @click="searchBooking(dataForm)"
                  ><span class="icons-center material-icons">search</span
                  >Search</md-button
                >
              </div>

            </div>
          </div>

          <div v-if="getBookingTable"
          class = "fixBlur">
            <md-table
              v-model="items"
              md-sort="name"
              md-sort-order="asc"
              md-card
              @md-selected="onSelect"
              :class="getTableHeight()"
            >
              <md-table-toolbar>
                <h1 v-if="items.length === 0" class="md-title">No Order found with the search criteria!.</h1>
                <h1 v-else class="md-title">{{ items.length }} Available Orders with the search criteria</h1>
                <h1 v-if="lenError != null" class="ErrorMessage md-title">{{ lenError }}</h1>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                
                <md-table-cell md-label="Doc Due" md-sort-by="docCut">
                  <h1 v-if="docCutDue >= item.docCut">🛑</h1>
                </md-table-cell>

                <md-table-cell md-label="Status" md-sort-by="deliveryStatus">{{item.deliveryStatus}}</md-table-cell>
                <md-table-cell md-label="Porcess" md-sort-by="deleteBit">{{item.deleteBit}}</md-table-cell>
                <md-table-cell md-label="Order#" md-sort-by="deliveryOrder">{{ item.deliveryOrder }}</md-table-cell>
                <md-table-cell md-label="Customer PO" md-sort-by="customerPO">{{item.customerPO}}</md-table-cell>
                <md-table-cell md-label="Doc Cutoff" md-sort-by="docCut">{{item.docCut | date}}</md-table-cell>
                <md-table-cell md-label="Cut Off" md-sort-by="cutLFD">{{item.cutLFD | date}}</md-table-cell>
                <md-table-cell md-label="Booking" md-sort-by="bookObl">{{item.bookObl}}</md-table-cell>
                <md-table-cell md-label="CTN">{{item.ctnrCount == null ? "0" : item.ctnrCount}}</md-table-cell>
                <md-table-cell md-label="ASN">{{item.ctnrAssign == null ? "0" : item.ctnrAssign}}</md-table-cell>
                <md-table-cell md-label="REM">{{Number(item.ctnrCount) - Number(item.ctnrAssign)}}</md-table-cell>
                <md-table-cell md-label="Ctype" md-sort-by="ctnrType">{{item.ctnrType}}</md-table-cell>
                <md-table-cell md-label="Pickup Loc" md-sort-by="pickupLoc">{{item.pickupLoc}}</md-table-cell>
                <md-table-cell md-label="Delivy To" md-sort-by="deliveryTo">{{item.deliveryTo}}</md-table-cell>
                <md-table-cell md-label="Pickup Tml" md-sort-by="ctnrPickup">{{item.ctnrPickup}}</md-table-cell>
                <md-table-cell md-label="Dropoff Tml" md-sort-by="ctnrDropOff">{{ item.ctnrDropOff }}</md-table-cell>
                <md-table-cell md-label="SCAC" md-sort-by="scac">{{item.scac}}</md-table-cell>
                <!-- <md-table-cell md-label="Vessel" md-sort-by="vesselName">{{item.vesselName}}</md-table-cell>
                <md-table-cell md-label="Voyage" md-sort-by="voyage">{{item.voyage}}</md-table-cell> -->
                <md-table-cell md-label="Material" md-sort-by="arktx">{{item.arktx}}</md-table-cell>
                <md-table-cell md-label="BK Remark" md-sort-by="remark_bsi">{{item.remark_bsi}}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>

          <div class="alwaysShow">
            <div>
              <md-dialog-actions>
                <md-button class="md-raised custButton" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Back</md-button>
                <md-button type="submit" class="md-raised custButton md-primary" :disabled="lenError != null || selected == null"><span class="icons-center material-icons">create</span>Assign</md-button>
              </md-dialog-actions>
            </div>
          </div>
        </form>
      </md-dialog-content>
    </md-dialog>
     </div>
  </div>
</template>

<style scoped>
form {
  min-width: 840px;
  max-width: 1200px;
  margin: 0px;
}

.tableFormat {
  height: 400px;
}

.tableMinFormat {
  height: 100px;
}

form .md-field {
  margin: 0 0;
}

.md-dialog {
    max-height: 90% !important;
}

.inputBox {
  border: 1px solid #ae7939;
  border-radius: 0px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 180px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxWide {
  border: 1px solid #a4cdf5;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 425px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBtnSpace {
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxDouble {
  width: 450px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputBoxMessage {
  width: 425px;
  margin: auto;
}



.inputBoxInbound {
  border: 1px solid #8fc0f0;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxInbound:hover {
  border: 2px solid #fffc44;
  border-radius: 5px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
  background-color: #c0f4b3;
}

.alwaysShow {
  position: fixed;
  right: 1px;
  top: 1px;
}

.ErrorMessage {
  color: #f14668 !important;
}

.redButton {
  background-color: #c50000;
  z-index: 4;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}

.custButton {
  margin: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.custButtonWide {
  width: 200px;
  height: 40px;
  line-height: 40px;
  font-size: 0.9rem;
}

.SpinnerAdj {
  margin-left: 90px;
}

.heading {
  padding-top: 0px;
  margin-bottom: 0;
  color: #555555;
  width: 92%;
  line-height: 2;
  font-size: 30px;
  font-family: Roboto Slab;
  margin-left: 5px;
}

.layout {
  padding-top: 7px;
  padding-bottom: 7px;
  width: 92%;
  line-height: 1.5;
  color: #555555;

  font-family: Roboto Slab;
  margin: auto;
}

.md-table-row {
  background: white;
}

.md-table.md-theme-default .md-table-row.md-selected-single {
  background: yellow;
}
</style>
<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import dateFormat from "../utils/dateFormat";
import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
import DatePickerBackdate from "./DatePickerBackDate.vue";
import callingApiCenter from "../components/CallingApiCenter.vue";
//import api from "../api";
import { newAPIPost } from '../api/index.js'; 
import moment from 'moment';


const getInitialdataForm = () => ({
  salesOffice: "LGB",
  deliveryStatus: null,
  deviveryOrder: null,
  oldDeviveryOrder: null,
  loads: [],
  deliveryType: null,
  ctnrType: null,
  arktx: null,
  bookObl: null,
  scac: null,
  grade: null,
  customerPO: null,
  sort1: null,
  ctnrType: null,
  cutLFD: {
    startDate: null,
    endDate: null,
  },
});

export default {
  components: { AutocompleteCcicLocationSelect, callingApiCenter,DatePickerBackdate },
  mixins: [validationMixin],
  props: {
    mode: String,
    action: Function,
  },
  data: () => ({
    showDialog: false,
    dataForm: getInitialdataForm(),
    items: [],
    selected: null,
    getBookingTable: false,
    getSearchBox: true,
    lenError: null,
    loads: [],
    notifyActive: false,
    notifyMessage: 'Cut off Start Date is required!',
    trimOption: [
      "deliveryOrder",
      "bookObl",
      "customerPO"
    ],
    docCutDue: dateFormat.getLocalDate(moment(moment().add(2,'days').startOf('d').toDate())),
  }),
  computed: {
    ...mapGetters([
      "getMasterDataByGroup",
      "getMasterDataName",
      "getUserProfile",
    ]),
  },

  validations: {
    dataForm: {
      salesOffice: {},
  
    },
  },

  methods: {
    trimTool(ent) {
      return ent == null ? null : ent.trim()
    },

    onSelect(item) {
      if (item == null) {
        this.lenError = null;
      } else {
        this.lenError = null;
        const count = item.ctnrCount == null ? 0 : Number(item.ctnrCount);
        const assigned = item.ctnrAssign == null ? 0 : Number(item.ctnrAssign);
        if (this.loads.length > count - assigned) {
          this.lenError = `Total selected container count exceed to this IBD by ${
            this.loads.length - (count - assigned)
          }!`;
        }
        const process = item.deleteBit == null ? "O" : item.deleteBit;
        if (process == "X") {
          this.lenError = `DO Closed!`;
        }
      }
      this.selected = item;
    },

    async openDialog(loads) {
      this.$store.commit("clearApiError");
      this.$v.dataForm.$reset();
      this.dataForm = getInitialdataForm();
      this.loads = loads;
      this.getBookingTable = false;
      this.getSearchBox = true;
      this.selected = null;
      this.notifyActive = false;
      this.dataForm.ctnrType = loads[0].ctnrType;
      this.dataForm.grade = loads[0].grade;
      this.dataForm.scac = loads[0].scac;
      this.dataForm.deliveryStatus = "I";
      this.dataForm.deliveryType = loads[0].deliveryType;
      this.dataForm.oldDeliveryOrder = loads[0].deliveryOrder;
        this.dataForm.cutLFD.startDate = moment().toDate();
        this.dataForm.cutLFD.endDate = moment().add(3,'months').endOf('d').toDate();
      console.log(loads);
      this.showDialog = true;
    },

    async searchBooking(item) {
      this.notifyActive = false;
      const request = JSON.parse(JSON.stringify(item));
      if (request.cutLFD.startDate == null) {
        this.notifyActive = true;
        return
      }
      request.cutLFD.startDate = dateFormat.getLocalDateOnly(request.cutLFD.startDate);
      if (request.cutLFD.endDate == null || request.cutLFD.endDate == "")
      {
          request.cutLFD.endDate = request.cutLFD.startDate;
      }
      else
      {
          request.cutLFD.endDate = dateFormat.getLocalDateOnly(request.cutLFD.endDate);
      }
      request.arktx = this.dataForm.grade;
      request.scac = this.dataForm.scac;
      request.deliveryType = this.dataForm.deliveryType;
      request.deliveryStatus = this.dataForm.deliveryStatus;
      request.deliveryOrder = this.dataForm.deliveryOrder;
      request.sort1 = this.dataForm.sort1;
      request.ctnrType = this.dataForm.ctnrType;


      for (const el of this.trimOption) {
        request[el] = this.trimTool(request[el]);
      }

      
      //api.post("/api/w/DOs/WebSearchBooking", request).then((res) => {
      newAPIPost("/api/w/DOs/WebSearchBooking", request).then((res) => {
        this.items = res;
        this.getBookingTable = true;
        this.getSearchBox = false;
      });
    },


    clearAction() {
      this.dataForm.cutLFD.startDate = moment().toDate();
      this.dataForm.deliveryOrder = null;
      this.dataForm.bookObl = null;
      this.dataForm.customerPO = null;
      this.dataForm.deliveryStatus = null;
      this.dataForm.scac = null;
      this.dataForm.grade = null;
      this.dataForm.sort1 = null;
      this.dataForm.ctnrType = null;
      this.$refs.refCarrier.querySelector('button.md-clear').click();
      
    },

    getValidationClass(fieldName) {
      const field = _(this.$v).lookup(fieldName);

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
      return {};
    },


    getTableHeight() {
       
       if (this.items.length === 0)
       {
          return {
          "tableMinFormat": true,
        };
       }
       else
       {
         return {
          "tableFormat": true,
        };
       }
        return {};
      },

   

    cancalAction() {
      this.lenError = null;
      if (this.getBookingTable == true) {
        this.$store.commit("clearApiError");
        this.getBookingTable = false;
        this.getSearchBox = true;
        this.selected = null;
      } else {
        this.$store.commit("clearApiError");
        this.showDialog = false;
      }
    },

    async doSaveUser() {
      this.$v.dataForm.$touch();
      // const time = moment().format('HH:mm:ss');
      // const date = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + time;

      if ( this.docCutDue >= this.selected.docCut)
      {
        if (confirm("Document Cutoff is about due. Please make sure Load can be confirmed before Doc-Cut Date!")) {
          const request = {
            salesOffice: this.dataForm.salesOffice,
            deliveryOrder: this.selected.deliveryOrder,
            oldDeliveryOrder: this.dataForm.oldDeliveryOrder,
            loads: this.loads.map((it) => ({
              user: it.user,
              seqNo: it.seqNo,
            })),
          };
          console.log(JSON.stringify(request));
          const loadRef = this.loads.map(it => it.seqNo).toString();
          //api.post("/api/w/DOs/WebMoveLoad", request).then((res) => {
          newAPIPost("/api/w/DOs/WebMoveLoad", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(request.oldDeliveryOrder, request.deliveryOrder, loadRef);
          });
        }
      }
      else{
        const request = {
            salesOffice: this.dataForm.salesOffice,
            deliveryOrder: this.selected.deliveryOrder,
            oldDeliveryOrder: this.dataForm.oldDeliveryOrder,
            loads: this.loads.map((it) => ({
              user: it.user,
              seqNo: it.seqNo,
            })),
          };
          console.log(JSON.stringify(request));
          const loadRef = this.loads.map(it => it.seqNo).toString();
          //api.post("/api/w/DOs/WebMoveLoad", request).then((res) => {
          newAPIPost("/api/w/DOs/WebMoveLoad", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            this.action(request.oldDeliveryOrder, request.deliveryOrder, loadRef);
          });
      }
    },

    handleCarrierChanged(id) {
      this.dataForm.scac = id;
    },
  },
};
</script>
